import { LearningOpportunity } from "@/server/backend-api";
import { InformationTextTabSection } from "@/components/Sections/InformationTextTabSection";

export const LEARNING_OPP_INFO_TEXT_TAB_SECTION_ID = "learning-opp-information";

interface Props {
  learningOpp: LearningOpportunity;
  highlightParticipantInfoTab?: boolean;
}

export function LearningOppInformationTextTabSection(props: Props) {
  const { highlightParticipantInfoTab, learningOpp } = props;

  // Merge learning activities into participant information markdown.
  const participantInformation: string[] = [
    learningOpp.participantInformation ?? "",
  ];
  if (learningOpp.learningActivities.length > 0) {
    participantInformation.push("\n## Learning activities");
    participantInformation.push(
      ...learningOpp.learningActivities.map(
        (la) => `\n### ${la.name}\n${la.description}`
      )
    );
  }

  return (
    <InformationTextTabSection
      sectionId={LEARNING_OPP_INFO_TEXT_TAB_SECTION_ID}
      defaultTabIndex={highlightParticipantInfoTab ? 2 : 0}
      tabs={[
        {
          title: "The story",
          markdownContent: learningOpp.description,
          sectionProps: { color: "light-yellow" },
        },
        {
          title: "The application process",
          markdownContent: learningOpp.admissionProcessInformation,
          sectionProps: { color: "light-yellow" },
        },
        {
          title: "Participant information",
          markdownContent: participantInformation.join(""),
          sectionProps: { color: "light-yellow" },
        },
      ]}
    />
  );
}
